import { render } from "./UploadImageContent.vue?vue&type=template&id=0ded9822&scoped=true"
import script from "./UploadImageContent.vue?vue&type=script&lang=js"
export * from "./UploadImageContent.vue?vue&type=script&lang=js"

import "./UploadImageContent.vue?vue&type=style&index=0&id=0ded9822&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ded9822"]])

export default __exports__